import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { QAOverlay } from "@/components/QAOverlay";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <QAOverlay />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#0D0D16",
                        border: "2px solid #000",
                        color: "#fff",
                        borderRadius: 0,
                        fontFamily: "Chivo, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
